import swal from 'sweetalert2'
import axios from 'axios'

import {
  getLast,
  findIndex,
  noReactive,
  getTheFirst,
  getBoolValue,
  checkVariable,
  getNumberFormat,
  getDifferenceInDays,
  getAllAssociatedValues,
  getTheFirstOccurrenceByKey,
} from '../../plugins/helper'
import {
  getColor,
  determinesInspectionAction,
} from '../../plugins/helperService'

export const defaultAdvanceKey = 'tipo_pago_id'

/**
 * @param {Array} rowsBill
 * @param {String} currentKey
 * @param {Boolean} advanceControl
 * @return {Number}
 */
export const getTotalInvoiceAndCheck = (rowsBill, currentKey, advanceControl) => {
  if (!checkVariable(advanceControl)) {
    advanceControl = false
  }

  let total = 0
  Object.keys(rowsBill).forEach(index => {
    const rows = rowsBill[index]
    const typePayment = advanceControl ? getTheFirstOccurrenceByKey(rows, defaultAdvanceKey, 'name') : null
    rows.forEach((row, key) => {
      const { name, value } = row
      if (name === currentKey && checkVariable(value)) {
        if (checkVariable(typePayment) && checkVariable(typePayment.id_reference) && typePayment.id_reference !== 1 && advanceControl) {
          total = total + parseFloat(value)
        }
        if (checkVariable(typePayment) && !checkVariable(typePayment.id_reference) && typePayment.value !== 1 && advanceControl) {
          total = total + parseFloat(value)
        }
        if (!checkVariable(typePayment) && !advanceControl) {
          total = total + parseFloat(value)
        }
      }
    })
  })

  return getNumberFormat(total)
}

export const getLastSummary = (summaries) => {
  return getLast(summaries)
}

export const inspeccionSuper = (inspection, budget) => {
  let result = false
  if (typeof budget === 'number') {
    result = Boolean(budget)
  } else if (typeof budget === 'string') {
    result = Boolean(Number(budget))
  }

  return inspection && result
}

export const deleteFileInvoiceAndCheck = async params => {
  const { url, id } = params

  return swal.fire({
    title: swal.i18n.t('confirmar'),
    text: swal.i18n.t('warning_text'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: swal.i18n.t('delete_text'),
    showLoaderOnConfirm: true,
    preConfirm: () => {
      return axios.delete(url, { params: { id } })
    },
    allowOutsideClick: () => false,
  })
}

/**
 * @param {Object} form
 * @param {Array} rows
 * @return {Object}
 */
export const handleTheLoadingOfInvoiceFiles = (form, rows) => {
  Object.keys(rows).forEach(index => {
    const currentElements = rows[index]
    if (Array.isArray(currentElements)) {
      currentElements.forEach(objValue => {
        const { id, type, files, name } = objValue
        if (type === 'file' && files && files.length > 0) {
          Object.keys(files).forEach(key => {
            const file = files[key]
            form[`${id}-${name}`] = file
          })
        }
      })
    }
  })

  return form
}

export const createDefaultActivityObject = (contractActivities, options) => {
  const tempContractActivities = noReactive(contractActivities)
  const activities = []
  let i = 0
  const { editable } = options
  if (tempContractActivities !== undefined) {
    for (const key in tempContractActivities) {
      if (tempContractActivities.hasOwnProperty(key)) {
        if (i === 0) {
          activities.push({
            id: 0,
            hide: true,
            visible: true,
            title: 'Modelo de casa',
          })
          activities.push({
            id: 0,
            hide: true,
            visible: true,
            title: 'Número de lote',
          })
        }
        const tempActivity = tempContractActivities[key]
        tempActivity.editable = editable
        activities.push(tempActivity)
        i++
      }
    }
  }

  return activities
}

export const createObjectActivities = (params, amountHouses) => {
  const activities = []
  let k = 0
  const length = amountHouses
  let id = params !== undefined ? params.id : 0
  while (k < length) {
    if (k === 0) {
      activities.push({
        id: k,
        hide: true,
        visible: true,
        title: 'Modelo de casa',
      })
      activities.push({
        id: k,
        hide: true,
        visible: true,
        title: 'Número de lote',
      })
    }
    id = id + 1
    activities.push({
      id: id,
      editable: true,
      hide: false,
      visible: true,
      name: ['nombre', 'porcentaje'],
      titles: ['Actividad', 'Porcentaje'],
      lugar: 'activity',
      tag: 'input',
      value: [],
      min: 1,
      max: 30,
    })
    k++
  }
  if (params !== undefined) {
    params.id = id
  }

  return activities
}

export const createObjectHouses = (length, model) => {
  const visibleRows = []
  let i = 0
  let id = 0
  let cantidadcasas = 1
  while (i < length) {
    let k = 0
    visibleRows[i] = []
    while (k < length) {
      if (k === 0) {
        id = id + 1
        visibleRows[i].push({
          id: id,
          name: 'modelo',
          value: model,
          editable: true,
          visible: true,
          lugar: 'house',
          tag: 'input',
          min: 2,
          max: 30,
        })
        visibleRows[i].push({
          id: id,
          name: 'numero_vivienda',
          value: cantidadcasas,
          editable: true,
          visible: true,
          lugar: 'house',
          tag: 'input',
          min: 2,
          max: 30,
        })
      }
      id = id + 1
      visibleRows[i].push({
        id: id,
        value: '0.00',
        visible: true,
        lugar: 'house',
      })
      k++
    }
    cantidadcasas = cantidadcasas + 1
    i++
  }

  return visibleRows
}

export const createObjectDefaultHouses = (originalHousesObject, originalActivities, housingPrice) => {
  let indexProcentaje = 0
  const totalPercent = []
  const fields = []
  const activities = createDefaultActivityObject(
    originalActivities,
    {
      editable: true,
    },
  )
  let columnsActivities = []
  const totalhouses = []
  let rows = []

  // Houses and field managements
  if (checkVariable(originalHousesObject)) {
    for (const key in originalHousesObject) {
      if (originalHousesObject.hasOwnProperty(key)) {
        let total = 0
        const temp = []
        let totalPercentOfHouse = 0
        totalPercent[indexProcentaje] = []
        const lengthFields = originalHousesObject[key].fields.length

        if (lengthFields > 0) {
          originalHousesObject[key].fields.forEach((field, index) => {
            if (index === 0) {
              temp.push({
                id: originalHousesObject[key].id,
                name: 'modelo',
                value: originalHousesObject[key].model,
                editable: false,
                visible: true,
                lugar: originalHousesObject[key].lugar,
                tag: 'input',
                min: 2,
                max: 191,
              })
              temp.push({
                id: originalHousesObject[key].id,
                name: 'numero_vivienda',
                value: originalHousesObject[key].numero_vivienda,
                editable: false,
                visible: true,
                lugar: originalHousesObject[key].lugar,
                tag: 'input',
                min: 2,
                max: 191,
              })
            }

            const temporarykey = index + 2
            const porcentaje = activities[temporarykey] !== undefined ? activities[temporarykey].value[1] : 0
            const residuo = (housingPrice * porcentaje) / 100
            const valueofhouse = (field.porcentaje_campo * residuo) / 100
            total = total + valueofhouse
            totalPercent[indexProcentaje].push({
              id: activities[temporarykey].id,
              percent: field.porcentaje_campo,
            })
            totalPercentOfHouse = totalPercentOfHouse + parseFloat(field.porcentaje_campo)
            temp.push({
              id: field.id,
              value: !isNaN(valueofhouse) ? getNumberFormat(valueofhouse) : 0,
              visible: true,
              lugar: originalHousesObject[key].lugar,
              styles: {
                background: getColor(field.porcentaje_campo),
                color: '#000',
                'font-weight': 'bold',
              },
            })
          })
        }
        totalhouses.push({
          id: originalHousesObject[key].id,
          total: !isNaN(total) ? total : 0,
          percent: totalPercentOfHouse / lengthFields,
          visible: true,
        })
        fields.push(temp)
        indexProcentaje++
      }
    }
  }

  // Activities
  if (activities.length > 0) {
    columnsActivities = activities
  }

  // Field management
  if (fields.length > 0) {
    rows = fields
  }

  return {
    rows,
    totalhouses,
    totalPercent,
    columnsActivities,
  }
}

/**
 * @param {Array} originalHousesObject
 * @param {Number} amountHouses
 */
export const createObjectDefaultHousesAuction = (originalHousesObject, amountHouses) => {
  let indexProcentaje = 0
  let tempActivities = []
  const totalPercent = []
  const fields = []
  const activities = []
  let zeroContract = false
  let columnsActivities = []
  const totalhouses = []
  let rows = []

  if (checkVariable(originalHousesObject)) {
    for (const key in originalHousesObject) {
      if (originalHousesObject.hasOwnProperty(key)) {
        tempActivities = createDefaultActivityObject(
          originalHousesObject[key].activities,
          {
            editable: true,
          },
        )
        const temp = []
        let total = 0
        let totalPercentOfHouse = 0
        totalPercent[indexProcentaje] = []
        const lengthFields = originalHousesObject[key].fields.length
        const housePrice = originalHousesObject[key].house_price
        if (lengthFields > 0) {
          originalHousesObject[key].fields.forEach((field, index) => {
            if (index === 0) {
              temp.push({
                id: originalHousesObject[key].id,
                name: 'modelo',
                value: originalHousesObject[key].model,
                editable: false,
                visible: true,
                lugar: originalHousesObject[key].lugar,
                tag: 'input',
                min: 2,
                max: 30,
                house_price: housePrice,
              })
              temp.push({
                id: originalHousesObject[key].id,
                name: 'numero_vivienda',
                value: originalHousesObject[key].numero_vivienda,
                editable: false,
                visible: true,
                lugar: originalHousesObject[key].lugar,
                tag: 'input',
                min: 2,
                max: 30,
                house_price: housePrice,
              })
            }

            const temporarykey = index + 2
            const porcentaje = tempActivities[temporarykey] !== undefined ? tempActivities[temporarykey].value[1] : 0
            const valueofhouse = (porcentaje * field.porcentaje_campo) / 100
            total = total + valueofhouse

            totalPercentOfHouse = totalPercentOfHouse + parseFloat(field.porcentaje_campo)

            temp.push({
              id: field.id,
              value: !isNaN(valueofhouse) ? getNumberFormat(valueofhouse) : 0,
              visible: true,
              lugar: originalHousesObject[key].lugar,
              styles: {
                background: getColor(field.porcentaje_campo),
                color: '#000',
                'font-weight': 'bold',
              },
            })
          })
        }
        totalhouses.push({
          id: originalHousesObject[key].id,
          total: !isNaN(total) ? total : 0,
          percent: totalPercentOfHouse / lengthFields,
          visible: true,
        })
        fields.push(temp)
        activities.push(tempActivities)
        indexProcentaje = indexProcentaje + 1
      }
    }
  }

  // Activities
  if (activities.length > 0) {
    columnsActivities = activities
    zeroContract = false
  } else {
    const newActivities = []
    const k = { id: 0 }
    let i = 0
    while (i < amountHouses) {
      newActivities.push(createObjectActivities(k, amountHouses))
      i++
    }
    columnsActivities = newActivities
    zeroContract = true
  }

  // Field management
  if (fields.length > 0) {
    rows = fields
  }

  return {
    rows,
    totalhouses,
    columnsActivities,
    zeroContract,
  }
}

const _traverseArrayByColumn = (array, column) => {
  return array.map(a => a[column])
}

export const calculationOfActivityPercentage = totalPercent => {
  if (totalPercent.length <= 0) {
    return null
  }
  const newTotalPercent = []
  const length = totalPercent[0].length
  let j = 0
  while (j < length) {
    const temp = _traverseArrayByColumn(totalPercent, j)
    const id = temp[0].id
    let suma = 0
    temp.forEach((v, k) => {
      suma = suma + parseFloat(v.percent)
    })
    newTotalPercent.push({
      id: id,
      total: Math.round10(suma / temp.length, -2),
      visible: true,
      lugar: 'activity',
    })
    j++
  }

  return newTotalPercent
}

/**
 * @param {Object} datos
 * @return {String}
 */
const _createBankAccountDetail = datos => {
  if (!checkVariable(datos)) {
    return ''
  }
  const datoName = findIndex(datos, 'nombre')
  const datoNumber = findIndex(datos, 'numero')
  const datoBank = findIndex(datos, 'tipo_banco.nombre')
  const datoType = findIndex(datos, 'tipo_cuenta_contable_banco.nombre')

  return `${datoName}(${datoBank},${datoType},${datoNumber})`
}

/**
 * @param {Array} rows
 * @param {Array} bills
 * @return {Array}
 */
export const inspectBillAndPayments = (rows, bills) => {
  const inspection = determinesInspectionAction(['forceInspectionTable'])
  const temRows = []
  if (checkVariable(bills) && bills.length > 0) {
    bills.forEach(bill => {
      const newResult = []
      const result = getAllAssociatedValues(rows, bill.id, 'id')
      const diffDays = getDifferenceInDays(bill.created_at)
      let newInspection = inspection
      // Abierto, rechazado, Cerrado y Verificado
      const isNotApproved = (checkVariable(bill.estado_id) && [1, 3, 4, 5].indexOf(bill.estado_id) !== -1)
      const itIsPaid = (checkVariable(bill.aprobado) && getBoolValue(bill.aprobado) === true)
      if ((getBoolValue(inspection) === false && isNotApproved) || (getBoolValue(inspection) === false && itIsPaid)) {
        newInspection = false
      }
      // Facturas con mas de 90 dias de creacion
      if (getBoolValue(inspection) === false && diffDays >= 90 && !checkVariable(bill.aprobado)) {
        newInspection = false
      }
      if (checkVariable(result) && Array.isArray(result)) {
        result.forEach(rVall => {
          const value = rVall.value
          const newObject = {
            ...rVall,
            editable: newInspection,
            value,
          }
          if ((checkVariable(bill.tipo_pago_banco)) && (rVall.name === 'tipo_pago_banco_id') && (newInspection === false)) {
            newObject.id_reference = value
            newObject.value = bill.tipo_pago_banco.nombre
          }
          if ((checkVariable(bill.tipo_pago)) && (rVall.name === 'tipo_pago_id') && (newInspection === false)) {
            newObject.id_reference = value
            newObject.value = bill.tipo_pago.nombre
          }
          if ((checkVariable(bill.proyecto_bancos)) && (rVall.name === 'cuenta_proyecto_banco_id') && (newInspection === false)) {
            const arrBankProject = getTheFirst(bill.proyecto_bancos)
            newObject.id_reference = value
            newObject.value = _createBankAccountDetail(arrBankProject)
          }
          if ((checkVariable(bill.bancos)) && (rVall.name === 'banco_id') && (newInspection === false)) {
            const bank = getTheFirst(bill.bancos)
            newObject.id_reference = value
            newObject.value = _createBankAccountDetail(bank)
          }
          // estado_id 3 => rechazada
          if (rVall.id !== 0 && rVall.name === 'file' && bill.estado_id !== 3) {
            newObject.editable = true
          }
          newResult.push(newObject)
        })
        temRows.push(newResult)
      }
    })
  }

  return temRows
}

/**
 * @param {Array} allRows
 * @return {Array}
 */
export const ignoreNonEditableItems = allRows => {
  const newAllRows = noReactive(allRows)
  const temRows = []
  let newIndex = 0
  if (newAllRows && newAllRows.length > 0) {
    newAllRows.forEach(rows => {
      if (Array.isArray(rows) && rows.length > 0) {
        const newRows = []
        const file = getTheFirstOccurrenceByKey(rows, true, 'editable')
        if (checkVariable(file)) {
          rows.forEach(row => {
            if (checkVariable(row.id_reference)) {
              row.value = row.id_reference
            }
            row.editable = true
            newRows.push(row)
          })
        } else {
          rows.forEach(row => {
            if (checkVariable(row.id_reference)) {
              row.value = row.id_reference
            }
            if (row.editable) {
              newRows.push(row)
            }
          })
        }

        if (newRows && newRows.length > 0) {
          temRows[newIndex] = newRows
          newIndex++
        }
      } else {
        console.warn('Los presentes valores no pueden ser procesados', JSON.stringify(rows))
      }
    })
  }

  return temRows
}
